import { useEffect, useRef } from 'react';

function PayPalButton({ onSuccess, onError }) {
  const paypalRef = useRef(null);
  const buttonsRef = useRef(null);
  const isInitializedRef = useRef(false);

  useEffect(() => {
    // Clear any existing content in the PayPal container
    if (paypalRef.current) {
      paypalRef.current.innerHTML = '';
    }

    const createButton = async () => {
      // Only create button if PayPal is loaded and container exists
      if (window.paypal && paypalRef.current) {
        try {
          // Create new buttons instance
          buttonsRef.current = await window.paypal.Buttons({
            style: {
              layout: 'vertical',
              shape: 'pill',
              label: 'paypal',
              height: 55,
            },
            fundingSource: window.paypal.FUNDING.PAYPAL,
            createOrder: (data, actions) => {
              return actions.order.create({
                purchase_units: [{
                  amount: {
                    value: '3.90',
                    currency_code: 'EUR'
                  },
                  description: 'Personalisierte Kindergeschichte'
                }]
              });
            },
            onApprove: async (data, actions) => {
              try {
                const order = await actions.order.capture();
                onSuccess(order, data.orderID);
              } catch (error) {
                onError(error);
              }
            },
            onError: (err) => {
              onError(err);
            }
          });

          // Render the buttons
          if (paypalRef.current && !isInitializedRef.current) {
            await buttonsRef.current.render(paypalRef.current);
            isInitializedRef.current = true;
          }
        } catch (error) {
          console.error('PayPal button creation failed:', error);
        }
      }
    };

    createButton();

    // Cleanup function
    return () => {
      if (buttonsRef.current) {
        buttonsRef.current.close();
      }
      isInitializedRef.current = false;
    };
  }, [onSuccess, onError]);

  return <div ref={paypalRef} />;
}

export default PayPalButton;
